import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useMemo, useState } from "react";
import Select from "react-select";
import qmsWorkflowActions from "../../../_actions/_qmsActions/qmsWorkflowActions";
import { QMS } from "../../../_constants/actionConstants";
import cmtIssueActions from "../../../_actions/_qmsActions/cmtIssueActions";

export default function CmtModal_ApplyWorkflow(props) {
  const { divisionId, tabId, issueId, modalState, toggleModal } = props;

  const fetching = useSelector((state) => state.qms.fetching);
  const dispatch = useDispatch();
  useEffect(() => dispatch(qmsWorkflowActions.getAll(divisionId, tabId)), []);
  const workflows = useSelector((state) => state.qms.openWorkflowLists[tabId] || null);
  const workflowOptions = useMemo(
    () => (workflows || []).map((w) => ({ value: w.workflowId, label: w.name })),
    [workflows]
  );

  const [selectedWorkflow, selectWorkflow] = useState(null);

  useEffect(() => {
    if (modalState.data && modalState.data.workflowId && workflowOptions)
      selectWorkflow(workflowOptions.find((o) => o.value === modalState.data.workflowId));
  }, [workflowOptions]);

  const handleClick_submit = (e) => {
    e.preventDefault();
    dispatch({
      type: QMS.ISSUE.UPDATE_CLIENT,
      issueId,
      fieldsToUpdate: {
        appliedWorkflowId: selectedWorkflow ? selectedWorkflow.value : null,
      },
    });
    dispatch(cmtIssueActions.update(issueId));
    toggleModal();
  };

  const closeBtn = (
    <button className="close" onClick={toggleModal}>
      <FontAwesomeIcon icon="times" className="fa-fw text-white" />
    </button>
  );

  return (
    <Modal isOpen={modalState.showModal} toggle={toggleModal} fade={false} size={"md"}>
      <ModalHeader toggle={toggleModal} className="bg-info text-white" close={closeBtn}>
        <FontAwesomeIcon icon="plus" className="fa-fw mr-2" />
        Apply Workflow
      </ModalHeader>
      <ModalBody>
        <div className="form-row mb-0">
          <div className="form-group mb-0 w-100">
            <label htmlFor="workflow" className="font-weight-bold mb-0">
              Select Workflow:
            </label>
            <Select
              id="workflow"
              name="workflow"
              value={selectedWorkflow}
              options={workflowOptions}
              onChange={(selected) => selectWorkflow(selected)}
              isClearable
            />
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="bg-lightgray">
        <div className="form-group form-row float-right mb-0">
          <button
            type="button"
            name="open"
            id="open"
            className="btn btn-primary mr-2"
            onClick={handleClick_submit}
          >
            {fetching && (
              <span className="mr-2 mt-1">
                <FontAwesomeIcon
                  icon="spinner"
                  className="loading-spinner"
                  style={{ color: "white" }}
                />
              </span>
            )}
            <b>Submit</b>
          </button>
          <button
            type="button"
            name="cancel"
            id="cancel"
            className="btn btn-secondary"
            onClick={toggleModal}
          >
            Cancel
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}
